import { Action, createAction } from 'redux-act';

import TimestampPayload from '../TimestampPayload';

interface DeleteAccountPayload {
  token?: string;
}

export const deleteAccount = createAction<DeleteAccountPayload>('DELETE_ACCOUNT');
export type DeleteAccountActionType = Action<DeleteAccountPayload>;

export const accountDeleted = createAction<TimestampPayload>('ACCOUNT_DELETED');

export const accountDeletionFailed = createAction<TimestampPayload>('ACCOUNT_DELETION_FAILED');
